import { Trans } from '@lingui/react/macro';
import React, { ReactNode } from 'react';
import UDText from 'ud-ui/components/text';

/**
 * Что оператору знать в день матча: порядок перед стартом, что безопасно, как читать панель и где
 * потом окажутся метки. Всё сверено на прогоне IMGM-1484 (`.claude/docs/video-markers.md`).
 */
function MatchDayTips() {
  return (
    <section className="bg-surfaceCard rounded-card flex flex-col gap-3 p-5" aria-labelledby="video-markers-guide-match-day-title">
      <UDText as="h2" variant="title-4" id="video-markers-guide-match-day-title">
        <Trans>Перед матчем и во время трансляции</Trans>
      </UDText>

      <ul className="flex flex-col gap-1 pl-2">
        <Tip>
          <Trans>
            <b>Перед стартом матча</b> включите запись (и эфир, если он есть) и проверьте, что в панели видеометок написано «подключён»
            и идёт «● Запись». Событие, случившееся до начала записи, получит метку без секунды в видео.
          </Trans>
        </Tip>
        <Tip>
          <Trans>
            <b>Одна программа на одно устройство.</b> Не открывайте ссылку табло одновременно в OBS и в vMix: клавиша метки OBS
            работает во всей системе, и метки задвоятся.
          </Trans>
        </Tip>
        <Tip>
          <Trans>
            <b>Обновить страницу табло или переподключиться безопасно.</b> События, которые уже были в матче, повторно метками не
            станут — даже если приложение статиста после повторного открытия матча выдаст им новые номера.
          </Trans>
        </Tip>
        <Tip>
          <Trans>
            <b>Сменили матч на устройстве</b> — ничего перенастраивать не нужно: новые метки сами пишутся к новому матчу.
          </Trans>
        </Tip>
        <Tip>
          <Trans>
            <b>Строка «Последнее событие»</b> показывает, на какой секунде записи случилось последнее событие матча, двумя способами:
            «по хронометражу» — по игровому времени события, «по получению» — когда событие дошло до табло; «задержка» — насколько
            статист внёс его позже, чем оно случилось. Обычно они расходятся на секунду-две. «—» — посчитать нельзя: например, событие
            было до начала записи или часы матча ещё не шли.
          </Trans>
        </Tip>
        <Tip>
          <Trans>
            <b>Где потом метки.</b> Метки сохраняются в ImGame вместе с матчем; в панели видны только их счётчики. По меткам будут
            нарезаться хайлайты из записи — это следующий этап, он в работе.
          </Trans>
        </Tip>
      </ul>
    </section>
  );
}

function Tip({ children }: { children: ReactNode }) {
  return (
    <li className="flex gap-2">
      <UDText variant="body-2" aria-hidden>
        •
      </UDText>
      <UDText variant="body-2">{children}</UDText>
    </li>
  );
}

export default React.memo(MatchDayTips);
